import React from 'react'
import NotFoundPage from "../Components/404"

const ErrorPage = () => {return <NotFoundPage/>}
export default ErrorPage;